import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-reportes-dsi',
  templateUrl: './reportes-dsi.component.html',
  styleUrls: ['./reportes-dsi.component.css']
})
export class ReportesDsiComponent {

  powerBiUrlDSI: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) { 
    this.powerBiUrlDSI = this.sanitizeUrl(environment.powerBiUrlDSI);
  }

  ngOnInit(): void {
  }

  sanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


}
